import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { MoveClients } from "../../../components/Client/MoveClients";

export interface IMoveClientListPage {}

export const MoveClientListPage: FC<IMoveClientListPage> = (
  props: IMoveClientListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Move Clients"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<MoveClients />}
    />
  );
};
